import { Flex, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { CSSProperties, JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon, Text } from '@feathr/components';
import { cssVar } from '@feathr/hooks';

import { useDonationFormBuilder } from '../../../useDonationFormBuilder';
import SuggestedAmount from './SuggestedAmount';

function SuggestedAmounts(): JSX.Element {
  const { t } = useTranslation();
  const {
    amounts: contextAmounts,
    monthlyAmounts: contextMonthlyAmounts,
    donationFrequency,
    minValue,
  } = useDonationFormBuilder();

  // Determine which amounts to show based on frequency
  const options = donationFrequency === 'monthly' ? contextMonthlyAmounts : contextAmounts;

  function handleAddOption(): void {
    options.add({ description: '', value: minValue?.toString() ?? '' });
  }

  return (
    <Stack>
      <Flex align={'center'} justify={'space-between'}>
        <Text.DefaultMedium c={cssVar('--color-text-heading')}>
          {t('Suggested amounts')}
        </Text.DefaultMedium>
        <Button
          disabled={options.length >= 6}
          onClick={handleAddOption}
          style={{ ['--button-spacing-horizontal']: 'var(--spacing-2)' } as CSSProperties}
          type={'icon-small-outlined'}
        >
          <Icon.Add />
        </Button>
      </Flex>
      {options.map((option) => (
        <SuggestedAmount key={option.id} option={option} />
      ))}
    </Stack>
  );
}

export default observer(SuggestedAmounts);
